<div class="auth-container">
  <div class="auth-background">
    <div class="background-pattern"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <div class="auth-header">
        <div class="app-logo">
          <img
            class="logo-img"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
          <h1 class="app-title">ReBall</h1>
        </div>

        @if (!resetSuccess) {
        <h2 class="auth-title">Reset Your Password</h2>
        <p class="auth-subtitle">Enter your email and new password</p>
        } @else {
        <h2 class="auth-title">Password Reset Complete!</h2>
        <p class="auth-subtitle">Redirecting you to sign in...</p>
        }
      </div>

      @if (!resetSuccess) {
      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="onSubmit()"
        class="auth-form"
      >
        <div class="form-group">
          <label class="form-label" for="email">Email Address</label>
          <div class="input-wrapper">
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-input"
              [class.error]="submitted && f['email']?.errors"
              placeholder="Enter your email address"
            />
            <div class="input-icon">
              <lucide-icon name="mail" [size]="18"></lucide-icon>
            </div>
          </div>
          <div *ngIf="submitted && f['email']?.errors" class="error-message">
            <div *ngIf="f['email']?.errors?.['required']">
              Email is required
            </div>
            <div *ngIf="f['email']?.errors?.['email']">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="newPassword">New Password</label>
          <div class="input-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="newPassword"
              formControlName="newPassword"
              class="form-input"
              [class.error]="submitted && f['newPassword']?.errors"
              placeholder="Enter new password"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              tabindex="-1"
            >
              <lucide-icon
                [name]="showPassword ? 'eye-off' : 'eye'"
                [size]="18"
              ></lucide-icon>
            </button>
          </div>
          <div
            *ngIf="submitted && f['newPassword']?.errors"
            class="error-message"
          >
            <div *ngIf="f['newPassword']?.errors?.['required']">
              Password is required
            </div>
            <div *ngIf="f['newPassword']?.errors?.['minlength']">
              Password must be at least 6 characters
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="confirmPassword"
            >Confirm Password</label
          >
          <div class="input-wrapper">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-input"
              [class.error]="submitted && (f['confirmPassword']?.errors || resetPasswordForm.errors?.['passwordMismatch'])"
              placeholder="Confirm new password"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="toggleConfirmPasswordVisibility()"
              tabindex="-1"
            >
              <lucide-icon
                [name]="showConfirmPassword ? 'eye-off' : 'eye'"
                [size]="18"
              ></lucide-icon>
            </button>
          </div>
          <div
            *ngIf="submitted && f['confirmPassword']?.errors"
            class="error-message"
          >
            <div *ngIf="f['confirmPassword']?.errors?.['required']">
              Please confirm your password
            </div>
          </div>
          <div
            *ngIf="submitted && !f['confirmPassword']?.errors && resetPasswordForm.errors?.['passwordMismatch']"
            class="error-message"
          >
            <div>Passwords do not match</div>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="loading"
          class="auth-button primary"
          [class.loading]="loading"
        >
          <div class="button-content">
            <div class="button-spinner" *ngIf="loading"></div>
            <span class="button-text">{{
              loading ? "Resetting..." : "Reset Password"
            }}</span>
          </div>
        </button>

        <div class="auth-divider">
          <span>Remember your password?</span>
        </div>

        <button type="button" routerLink="/login" class="auth-button secondary">
          Back to Sign In
        </button>
      </form>
      } @else {
      <div class="success-content">
        <div class="success-icon">
          <lucide-icon
            name="circle-check"
            [size]="48"
            color="#10b981"
          ></lucide-icon>
        </div>
        <div class="success-message">
          <h3>Success!</h3>
          <p>
            Your password has been reset successfully. You can now sign in with
            your new password.
          </p>
        </div>

        <button
          type="button"
          (click)="goBackToLogin()"
          class="auth-button primary"
        >
          Go to Sign In
        </button>
      </div>
      }
    </div>
  </div>
</div>
